import Vue from 'vue'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'

export default {
  props: [
    'isClientDialogOpen',
    'maintainerId'
  ],
  data () {
    return {
      iesAlias: '',
      isLinkOrUnlinkLoading: false,
      linkedClients: [],
      linkedClientListPage: 1,
      linkedClientSearch: '',
      linkedClientOrder: 'asc',
      isLinkedClientListLoading: false,
      linkedClientSelectionOrder: [
        { text: 'Ordem alfabética - Crescente', value: 'asc' },
        { text: 'Ordem alfabética - Decrescente', value: 'desc' }
      ],
      unlinkedClientListPage: 1,
      unlinkedClientSearch: '',
      unlinkedClientOrder: 'asc',
      isUnlinkedClientListLoading: false,
      unlinkedClientSelectionOrder: [
        { text: 'Ordem alfabética - Crescente', value: 'asc' },
        { text: 'Ordem alfabética - Decrescente', value: 'desc' }
      ]
    }
  },
  mounted () {
    this.getUnlinkedClients()
    this.linkedClients = this.getterSelectedMaintainer.clients.map((client) => {
      Vue.set(client, 'isEditing', false)
      Vue.set(client, 'showEditIcon', false)

      return client
    })
  },
  computed: {
    ...mapGetters([
      'getterClients',
      'getterSelectedMaintainer'
    ]),
    filteredLinkedClients () {
      if (this.linkedClientSearch) {
        const newClientList = this.getterSelectedMaintainer.clients.filter((client) => {
          return client.name.toLowerCase().includes(this.linkedClientSearch.toLowerCase())
        })

        return newClientList
      }

      return this.getterSelectedMaintainer.clients
    }
  },
  methods: {
    ...mapMutations([
      'CLEAR_CLIENTS',
      'CLEAR_SELECTED_MAINTAINER',
      'ADD_CLIENT',
      'REMOVE_CLIENT',
      'ADD_CLIENT_TO_MAINTAINER',
      'REMOVE_CLIENT_FROM_MAINTAINER',
      'SHOW_CLIENT_EDIT_ICON',
      'HIDE_CLIENT_EDIT_ICON',
      'TOGGLE_CLIENT_IS_EDITING',
      'UPDATE_CLIENT_IES_ALIAS'
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    }),
    ...mapActions([
      'actionGetOneMaintainer',
      'actionGetUnlinkedClients',
      'actionLinkClientToMaintainer',
      'actionUnlinkClientFromMaintainer',
      'actionUpdateClientIesAlias'
    ]),
    showClientEditIcon (item) {
      this.SHOW_CLIENT_EDIT_ICON(item.clientid)
    },
    hideClientEditIcon (item) {
      this.HIDE_CLIENT_EDIT_ICON(item.clientid)
    },
    startEditingIesAlias (item) {
      this.iesAlias = item.ies_alias
      this.TOGGLE_CLIENT_IS_EDITING(item.clientid)

      this.HIDE_CLIENT_EDIT_ICON(item.clientid)
    },
    updateIesAlias (item) {
      this.isLinkOrUnlinkLoading = true

      const params = {
        clientId: item.clientid,
        iesAlias: this.iesAlias
      }

      this.actionUpdateClientIesAlias(params)
        .then((response) => {
          this.UPDATE_CLIENT_IES_ALIAS(response)

          this.addToast({
            text: 'Cliente atualizado com sucesso!',
            type: 'success'
          })
        })
        .catch((e) => {
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })
        })
        .finally(() => {
          this.TOGGLE_CLIENT_IS_EDITING(item.clientid)

          this.isLinkOrUnlinkLoading = false
        })
    },
    getUnlinkedClients () {
      this.CLEAR_CLIENTS()
      this.isUnlinkedClientListLoading = true

      const params = {
        search: this.unlinkedClientSearch || '',
        sortDirection: this.unlinkedClientOrder,
        page: this.unlinkedClientListPage,
        rowsPerPage: 20,
        idAccount: this.getterSelectedMaintainer.id
      }

      this.actionGetUnlinkedClients(params)
        .then(() => {
          this.isUnlinkedClientListLoading = false
        })
        .catch((e) => {
          this.isUnlinkedClientListLoading = false
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })
        })
    },
    linkClientToMaintainer (client) {
      this.isLinkOrUnlinkLoading = true
      const params = {
        clientId: client.clientid,
        accountId: this.getterSelectedMaintainer.id
      }

      Vue.set(client, 'isEditing', false)
      Vue.set(client, 'showEditIcon', false)

      this.actionLinkClientToMaintainer(params)
        .then((response) => {
          this.isLinkOrUnlinkLoading = false

          this.addToast({
            text: response.message,
            type: 'success'
          })

          this.REMOVE_CLIENT(client)

          this.ADD_CLIENT_TO_MAINTAINER(client)
        })
        .catch((e) => {
          this.isLinkOrUnlinkLoading = false
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })
        })
    },
    unlinkClientFromMaintainer (client) {
      this.isLinkOrUnlinkLoading = true
      const params = {
        clientId: client.clientid,
        accountId: this.getterSelectedMaintainer.id
      }

      this.actionUnlinkClientFromMaintainer(params)
        .then((response) => {
          this.isLinkOrUnlinkLoading = false
          this.REMOVE_CLIENT_FROM_MAINTAINER(client)
          this.ADD_CLIENT(client)

          this.addToast({
            text: response.message,
            type: 'success'
          })
        })
        .catch((e) => {
          this.isLinkOrUnlinkLoading = false
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })
        })
    },
    clearLinkedClientFilter () {
      this.linkedClientSearch = ''
      this.linkedClientOrder = 'asc'
    },
    sortLinkedClients () {
      this.filteredLinkedClients.sort((previousClient, nextClient) => {
        if (this.linkedClientOrder === 'asc') {
          return previousClient.name.toLowerCase().localeCompare(nextClient.name)
        }

        if (this.linkedClientOrder === 'desc') {
          return nextClient.name.toLowerCase().localeCompare(previousClient.name)
        }

        return 0
      })
    },
    clearUnlinkedClientFilter () {
      this.clientSearch = ''
      this.getUnlinkedClients()
    },
    changeUnlinkedClientListPage () {
      this.getUnlinkedClients()
    },
    closeClientsDialog () {
      this.CLEAR_SELECTED_MAINTAINER()
      document.querySelector('body').classList.remove('overflow-y-hidden')
      this.$emit('emit-close-client-dialog')
    }
  }
}
